import React, { useEffect, useState, useContext } from "react";
import { Table, Modal, Popconfirm, Select } from "antd";
import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import {
  deleteAllowanceMethod,
  getAllAllowances,
} from "../../service/ApiServices";
import CreateAllowanceCategoryModal from "./createAllowanceCategory";
import { ArrowLeft } from "lucide-react";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";  
const AllowanceCategories = () => {
  const { user } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [isAllowanceAdd, setIsAllowanceAdd] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAllowance, setSelectedAllowance] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 });
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false)
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize)
  const pageSizeOptions = [5, 10, 20, 50, 100]

  const fetchData = async (current = 1, pageSize = 5) => {
    setLoading(true);
    let data = await getAllAllowances({ search, setLoading, page: current, limit: pageSize });
    setData(data);
    setPagination(prev => ({ ...prev, total: data.total }));
    setLoading(false);

  };
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData(pagination.current, pagination.pageSize);
      setIsAllowanceAdd(false);
      setSelectedAllowance(null);
    }, 600);
    return () => {
      clearTimeout(handler);
    };
  }, [search, pagination.current, pagination.pageSize]);  
  
  useEffect(() => {
    if (isAllowanceAdd || isDelete) {
      fetchData(pagination.current, pagination.pageSize);
      setIsAllowanceAdd(false);
    }
  }, [isAllowanceAdd, isDelete]);
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setSelectedAllowance(null);
    setIsModalOpen(false);
  };

  const handleAllowanceAdding = () => {
    setIsAllowanceAdd(true);
  };
  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };



  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 }
    setPagination(newPagination)
    setPageSizeModalVisible(false)
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Allowance Type",
      dataIndex: "allowanceType",
      key: "allowanceType",
      render: (allowanceType) => (
        <span
          className={`badge ${
            allowanceType === "Fixed" ? "badge-linesuccess" : "badge-linedanger"
          }`}
          style={{ width: 80, padding: 6 }}
        >
          <Link to="#" style={{ cursor: "default", fontSize: 14 }}>
            {allowanceType === "Fixed" ? "Fixed" : "Variable"}
          </Link>
        </span>
      ),
    },
    {
      title: "Allowance Frequency",
      dataIndex: "isOneTime",
      key: "isOneTime",
      render: (isOneTime) => (
        <span>{isOneTime ? "One-Time" : "Recurring"}</span>
      ),
    },
    {
      title: "Show In Pay Slip",
      dataIndex: "showPaySlip",
      key: "showPaySlip",
      render: (showPaySlip) =>
        showPaySlip == true ? (
          <span className="badge bg-success">Yes</span>
        ) : (
          <span className="badge bg-primary">No</span>
        ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <td className="action-table-data">
        <Link
          className={`me-2 p-2 ${
            user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "edit") 
              ? '' 
              : 'disabled'
          }`}
          to="#"
          onClick={() => {
            if (user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "edit")) {
              setSelectedAllowance(record);
              setIsModalOpen(true);
            }
          }}
          title={
            !(user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "edit"))
              ? "You don't have permission to edit allowances" 
              : "Edit allowance"
          }
        >
          <i data-feather="edit" className="feather-edit"></i>
        </Link>
      
        <Popconfirm
          title="Delete the Allowance"
          description="Are you sure to disable this Allowance?"
          onConfirm={() => {
            if (user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "delete")) {
              deleteAllowanceMethod({
                id: record._id,
                setIsDelete,
                setLoading,
              });
            }
          }}
          onCancel={() => console.log("Cancelled")}
          okText="Yes"
          cancelText="No"
          disabled={
            !(user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "delete"))
          }
        >
          <Link 
            className={`confirm-text p-2 ${
              user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "delete") 
                ? '' 
                : 'disabled'
            }`}
            title={
              !(user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "delete"))
                ? "You don't have permission to delete allowances" 
                : "Delete allowance"
            }
          >
            <i data-feather="trash-2" className="feather-trash-2"></i>
          </Link>
        </Popconfirm>
      </td>
      ),
    },
  ];

  return (
    <div className="page-wrapper-lt">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container ">
              <div>
                <ArrowLeft size={32} />
              </div>

              <div className="page-title">
                <h4>Allowance Types</h4>
                <h6>Manage your allowances</h6>
              </div>
            </div>
            <div className="page-btn">
  <a 
    className={`btn btn-added ${
      user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "create") 
        ? '' 
        : 'disabled'
    }`}
    onClick={() => {
      if (user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "create")) {
        setIsModalOpen(true);
      }
    }}
    title={
      !(user?.permissions && hasPermission(user.permissions, "HRM", "Allowance Categories", "create"))
        ? "You don't have permission to create new allowances" 
        : "Create new allowance"
    }
  >
    <PlusCircle className="me-2" />
    New
  </a>
</div>
          </div>
       
        </div>

        <div className="card table-list-card-grid">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <Link className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
                <div className="wordset">
                <style>
    {`
      @media (max-width: 767px) {
        .wordset {
          margin-bottom: 18px !important;
        }
      }
    `}
  </style>
                  <ul>
                    <li>
                      <a
                        href="#"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="pdf"
                      >
                        <img src="assets/img/icons/pdf.svg" alt="pdf" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="excel"
                      >
                        <img src="assets/img/icons/excel.svg" alt="excel" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="print"
                      >
                        <img src="assets/img/icons/printer.svg" alt="print" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <div className="search-set">
                                <a href="#" className="btn btn-filter" id="filter_search">
                                    <Sliders className="me-2" />Filter
                                </a>
                            </div> */}
            </div>
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={columns}
                dataSource={data}
                rowKey="value"
                onChange={handleTableChange}                  pagination={{
                    current: pagination.current,
                    pageSizeOptions: ["5", "10", "20", "50"],
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total ${total} items`
                  }}
                  // footer={() => (
                  //   <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  //     <button className="btn btn-primary btn-sm" onClick={() => setPageSizeModalVisible(true)}>
                  //       Change Page Size
                  //     </button>
                  //   </div>
                  // )}
                />
            </div>
          </div>
        </div>
      </div>

      <Modal
        zIndex={200000}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <CreateAllowanceCategoryModal
          handleAllowanceAdding={handleAllowanceAdding}
          handleCancel={handleCancel}
          selectedAllowance={selectedAllowance}
        />
      </Modal>
      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button key="cancel" className="btn btn-cancel" onClick={() => setPageSizeModalVisible(false)}>
            Cancel
          </button>,
          <button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select style={{ width: "100%" }} value={tempPageSize} onChange={(value) => setTempPageSize(value)}>
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </div>
  );
};

export default AllowanceCategories;
